import script from "./RecentlyViewed.vue?vue&type=script&setup=true&lang=js"
export * from "./RecentlyViewed.vue?vue&type=script&setup=true&lang=js"

import "./RecentlyViewed.vue?vue&type=style&index=0&id=d1c28e82&lang=css"

const __exports__ = script;

export default __exports__